import { featureFlag } from '@/modules/common/helpers/feature-flag';
import { httpClient } from '@/modules/common/services/http/http-client';
import type { HttpClient } from '@/modules/common/services/http/http-client';
import { FeatureFlags } from '@/types/models/FeatureFlags';

const ENABLE_NEW_ADDRESS_ROUTE = FeatureFlags.ENABLE_NEW_CEP;

const bffHttpClient: HttpClient = httpClient.withOptions({
  baseURL: process.env.VUE_APP_BFF_URL
});

interface IAddress {
  zipcode: string;
  street: string;
  neighborhood: string;
  city: string;
  state: string;
  message?: string;
}

export interface INewAddress {
  address: {
    zipcode: string;
    street: string;
    neighborhood: string;
    city: string;
    state: {
      key: string;
      value: string;
    };
  };
}

export async function getAddressByZipCode(zipcode: string) {
  const isEnabled = await featureFlag.isEnabled(ENABLE_NEW_ADDRESS_ROUTE);

  if (isEnabled) {
    const cep = await bffHttpClient.get<INewAddress>(
      `/onboarding/v2/address?zipcode=${zipcode.replace('-', '')}`
    );
    return {
      zipcode: cep.address.zipcode,
      street: cep.address.street,
      neighborhood: cep.address.neighborhood,
      city: cep.address.city,
      state: cep.address.state.key
    };
  } else {
    return httpClient.get<IAddress>(`/api/v2/account/zipcode/${zipcode}`);
  }
}
